import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  NumericalGroupSettingsContainer, type NumericalGroupSettingsContainerProps,
} from './numericalGroupSettings.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    NumericalGroupSettings: NumericalGroupSettingsContainerProps;
  }
}

modalRenderer.register('NumericalGroupSettings', NumericalGroupSettingsContainer);
